var _ = require('lodash')
let constants = require('./app-constants')
let textConstants = constants.text

// var
var TextParser = function (constantName, options) {
  if (!constantName) return
  if (!textConstants[constantName]) return

  let data = _.get(options, 'data')
  let compiled = _.template(textConstants[constantName])
  return compiled(data)
}

module.exports = TextParser



// WEBPACK FOOTER //
// ./js/common/text-parser.js